import { useDraggable as useDndDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";

import { getIsTouchDevice } from "@/utils/getIsTouchDevice";
import { twMerge } from "@/utils/twMerge";

export function useDraggable(options: {
  id: string;
  type: "file" | "folder";
  className?: string;
  isOverlay?: boolean;
  parentId?: string;
  position?: number;
  disabled?: boolean;
}) {
  const isTouchDevice = getIsTouchDevice();
  const { listeners, setNodeRef, transform, isDragging } = useDndDraggable({
    id: options.id,
    disabled: isTouchDevice || options.disabled,
    data: {
      id: options.id,
      type: options.type,
      parentId: options.parentId,
      position: options.position,
    },
  });

  return {
    setNodeRef,
    isDragging,
    props: {
      style: {
        transform: options.isOverlay ? CSS.Translate.toString(transform) : undefined,
      },
      // No keyboard sensor, so dnd-kit's `attributes` would only add a dead Tab stop and description
      ...listeners,
    },
  };
}

export const Draggable = function Draggable({
  id,
  type,
  parentId,
  position,
  disabled,
  isOverlay,
  className,
  children,
  ...rest
}: {
  id: string;
  type: "file" | "folder";
  className?: string;
  isOverlay?: boolean;
  parentId?: string;
  position?: number;
  disabled?: boolean;
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>) {
  const { setNodeRef, isDragging, props } = useDraggable({
    id,
    type,
    parentId,
    position,
    disabled,
    isOverlay,
  });

  return (
    <div
      ref={setNodeRef}
      {...props}
      className={twMerge(
        "cursor-default",
        isDragging && "opacity-70",
        isOverlay && "opacity-80",
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
};
